export function backToTop() {
  const button = document.querySelector('.back-to-top')
  if (!button) return

  button.hidden = false

  const toggleVisibility = () => {
    const isVisible = window.scrollY > 300
    button.setAttribute('data-visible', isVisible)
  }

  window.addEventListener('scroll', toggleVisibility, { passive: true })
  toggleVisibility()

  button.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  })
}
